import { DirectUpload, DirectUploadDelegate } from "@rails/activestorage"
import humps from "humps"
import invariant from "tiny-invariant"
import { getMetaVar } from "./getMetaVar"

const directUploadsUrl = getMetaVar("direct-uploads-url")

export const directFileUpload = async (
  file: FileList[number],
  progressDelegate?: DirectUploadDelegate
): Promise<any> => {
  const data = await uploadFile(file, progressDelegate)
  return humps.camelizeKeys(data)
}

const uploadFile = (file: File, progressDelegate?: DirectUploadDelegate) => {
  invariant(directUploadsUrl, "Direct uploads URL meta tag is not set")

  return new Promise((resolve, reject) => {
    const upload = new DirectUpload(file, directUploadsUrl, progressDelegate)

    upload.create((error, blob) => {
      if (error) {
        reject(error)
      } else {
        resolve(blob)
      }
    })
  })
}
